import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {LoadingState} from '../../typings/types'
import {AuthModel} from '../../models/AuthModel'
import * as api from './AuthApi'

export interface AuthState {
  user: {
    data: AuthModel | null
    status: LoadingState
  }
}

const initialState: AuthState = {
  user: {
    status: 'idle',
    data: null,
  },
}

const validateToken = createAsyncThunk('users/validateToken', async () => {
  const response = await api.validateToken()
  return response.data
})

const authRedux = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setMfaAuth: (state, action: PayloadAction<AuthModel>) => {
      state.user.data = action.payload
      state.user.status = 'succeeded'
    },
    logout: (state) => {
      state.user.data = null
      state.user.status = 'idle'
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateToken.pending, (state) => {
        state.user.status = 'pending'
      })
      .addCase(validateToken.fulfilled, (state, action) => {
        state.user.data = action.payload
        state.user.status = 'succeeded'
      })
      .addCase(validateToken.rejected, (state) => {
        state.user.data = null
        state.user.status = 'failed'
      })
  },
})

export const actions = {...authRedux.actions, validateToken}
export const reducer = authRedux.reducer
